module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300.woff2?24f7b0944e9e03a905f9d7701573b2cd";